import React, {useContext} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../config/AuthContext";
import Login from "../newView/Login";
import {Content} from "antd/es/layout/layout";
import AppHeader from "./avaluacio/components/AppHeader";
import AppBreadcrumb from "./avaluacio/components/AppBreadcrumb";
import {Layout} from "antd";
import AppFooter from "./components/AppFooter";
import AppAvaluacioRoutes from "./routes/AppAvaluacioRoutes";

const Avaluacio = () => {
    const {isLoggedIn, userId, user} = useContext(AuthContext);
    if (isLoggedIn) {
        return (
            <>
                <Layout style={{minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>
                    <AppHeader/>
                    <Content style={{padding: '0 48px', flex: '1 0 auto'}}>
                        <AppBreadcrumb/>
                        <Layout style={{padding: '24px 0', background: '#fff', borderRadius: '8px'}}>
                            <AppAvaluacioRoutes/>
                        </Layout>
                    </Content>
                    <AppFooter/>
                </Layout>
            </>
        );
    } else {
        return (
            <Login/>
        );
    }
};

export default Avaluacio;
